import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
// Side-effect import: initialises i18next before the first render, so no component ever sees a
// raw key.
import '@/i18n'
import { startThemeSync } from '@/lib/theme'
import '@/index.css'

startThemeSync()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
